import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import './App.css';
import AboutPage from './About.js';
import HomePage from './Home.js';
import ContactPage from './Contact.js';
import PrivacyPolicy from './Privacy.js';
import PrivacyPolicy2 from './Privacy2.js';
import TermsPage from './Terms.js';

function App() {
  return (
    <Router>
    <div className="app">
      <header className="app-header">
        <h1>Chain'd</h1>
      </header>
      <main className="app-content">
        {/* Content Goes Here */}
        <Routes>
            <Route path="/about" element={<AboutPage />} />
            <Route path="/" element={<HomePage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/privacyPolicy" element={<PrivacyPolicy />} />
            <Route path="/normalPrivacyPolicy" element={<PrivacyPolicy2 />} />
            <Route path="/termsAndConditions" element={<TermsPage />} />
        </Routes>
      </main>
      <footer className="app-footer">
        <nav>
          <ul>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/about">About</Link></li>
              <li><Link to="/contact">Contact</Link></li>
              <li><Link to="/privacyPolicy">Privacy Policy</Link></li>
              <li><Link to="/normalPrivacyPolicy">BackToNormal Privacy Policy</Link></li>
              <li><Link to="/termsAndConditions">Terms And Conditions</Link></li>
          </ul>
        </nav>
      </footer>
    </div>
    </Router>
  );
}

export default App;
